import { useContext, useEffect, useState, useRef } from 'react';
import ContextStates from '../context/ContextStates';
import axios from 'axios';
import { FaUser } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosPhonePortrait } from "react-icons/io";
import { FaPen } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { IoMdTime } from "react-icons/io";
import { Url } from './Url';
import DetallePedido from './detallePedido';
import UploadFiles from './uploadFiles';

const FinalizarCompra = () => {
    const [total, setTotal] = useState(0)
    const [fecha, setFecha] = useState('')
    const [idComprobante, setIdComprobante] = useState(0)
    const [hora, setHora] = useState('')
    const [nombre, setNombre] = useState('')
    const [razonSocial, setRazonSocial] = useState('')
    const [cuit, setCuit] = useState('')
    const [fechaInicio, setFechaInicio] = useState('')
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1')
    const [efectivo, setEfectivo] = useState('')
    const [procesando, setProcesando] = useState(false)
    const [datosFactura, setDatosFactura] = useState('')
    const [finVenta, setFinVenta] = useState(false)
    const [uploadComprobante, setUploadComprobante] = useState(true)
    const [listEnvases, setListEnvases] = useState([])
    const [descuentos, setDescuentos] = useState([])
    const [horaCustom, setHoraCustom] = useState('00:00')
    const [custom, setCustom] = useState(false)
    const [domActual, setDomActual] = useState('')
    const [obsActual, setObsActual] = useState('')
    const { venta, precio, setVenta, setFormView, setViewOpen, modify, setModify, idUsuario, cliente,
        setClienteSelected, auxVenta, setAuxVenta, auxTotal, setAuxTotal, puntoVenta, porcentajeTransf,
        cuentasTransf, file, setTipoPaquete, setIdPaquete, setIdHtml, setUpload } = useContext(ContextStates);
    const componentRef = useRef();

    useEffect(() => {
        setIdHtml("comprobantes")
    }, [])

    useEffect(() => {
        if (cliente) {
            if (typeof cliente.domicilios !== 'undefined') {
                cliente.domicilios.forEach(element => {

                    if (element.actual === '1') {
                        setDomActual(element.domicilio)
                        if (typeof element.obsActual !== 'undefined')
                            setObsActual(element.observaciones)
                    }
                });
            }

        }

    }, [cliente])

    useEffect(() => {
        const calcTotal = () => {
            let aux = 0;
            let rData = [...descuentos]
            if (venta) {
                venta.forEach(element => {
                    if (!precio) {
                        if (element.tipopromo === '1' || element.tipopromo === '2') {
                            aux = aux + parseFloat(element.preciopromocion * element.cantidad);
                            let montoDesc = parseFloat(element.precio * element.cantidad) - parseFloat(element.preciopromocion * element.cantidad);
                            let descuento = {
                                id: element.id,
                                descripcion: element.descripcion,
                                monto: montoDesc
                            }
                            rData.push(descuento)
                        }
                        else {
                            if (element.tipopromo === '3') {
                                let precio = 0;
                                if (element.cantidad >= element.cantidadminima) {
                                    let cantPromos = parseFloat(element.cantidad) / parseFloat(element.cantidadminima);
                                    let cantPagos = element.cantidad - (parseFloat(element.cantidaddescuento) * cantPromos);
                                    precio = cantPagos * parseFloat(element.precio);
                                    let montoDesc = parseFloat(element.precio * element.cantidad) - precio;
                                    let descuento = {
                                        id: element.id,
                                        descripcion: element.descripcion,
                                        monto: montoDesc
                                    }
                                    rData.push(descuento)
                                } else {
                                    precio = parseFloat(element.cantidad) * parseFloat(element.precio);
                                }
                                aux = aux + precio;
                            } else {
                                aux = aux + parseFloat(element.precio) * element.cantidad;
                            }
                        }
                    }
                    else {
                        aux = aux + parseFloat(element.preciopormayor * element.cantidad);
                    }

                });

                setDescuentos(rData)
                setTotal(aux)
                if (venta.length > 0) {
                    setAuxVenta(venta)
                    setAuxTotal(aux)
                }
            }
        }
        calcTotal()
    }, [venta])

    useEffect(() => {
        const getMedios = async () => {
            const formData = new FormData()
            formData.append('cliente', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listmediospago.php',
                    method: 'POST',
                    data: formData,
                })
                setMedios(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getMedios()
    }, [])

    const handleHora = (time) => {
        setCustom(1)
        setHoraCustom(time)

    }

    const finalizarCompra = async () => {
        localStorage.removeItem('idCpbt')
        if (cliente && typeof cliente.id !== 'undefined' && cliente.domicilio !== 'undefined') {

            let tipoPrecio = 0;
            if (precio) {
                tipoPrecio = 1;
            }
            const rAuxVenta = JSON.stringify(venta)
            const auxEnvases = JSON.stringify(listEnvases)
            const auxDescuentos = JSON.stringify(descuentos)
            let hc = 0;
            if (custom) {
                hc = 1;
            }

            const formData = new FormData()

            formData.append('venta', rAuxVenta);
            formData.append('mediopago', medioPago);
            formData.append('idusuario', idUsuario);
            formData.append('cliente', cliente.id);
            formData.append('total', total);
            formData.append('puntoventa', puntoVenta);
            formData.append('tipoprecio', tipoPrecio);
            formData.append('envases', auxEnvases);
            formData.append('efectivo', efectivo);
            formData.append('descuentos', auxDescuentos);
            formData.append('hora', horaCustom);
            formData.append('custom', hc);

            try {
                const response = await axios({
                    url: Url + 'api/finVenta.php',
                    'Content-Type': 'application/json',
                    method: 'POST',
                    data: formData,
                    dataType: 'JSON',
                })
                console.log(response)
                setFecha(response.data.results.fecha);
                setHora(response.data.results.hora);
                setNombre(response.data.results.nombre)
                setRazonSocial(response.data.results.razonsocial)
                setCuit(response.data.results.cuit)
                setFechaInicio(response.data.results.fechainicio)
                setIdComprobante(response.data.results.idcomprobante)
                localStorage.setItem('idCpbt', response.data.results.idcomprobante)
                setAuxTotal(total)
                localStorage.removeItem('localVenta');
                setVenta([]);

                let aux = modify + 1;
                setModify(aux)
                setDatosFactura('')
                setFinVenta(true)
            } catch (e) {
                console.log(e)
            }
        }
    }

    const editCliente = () => {
        if (cliente) {
            setClienteSelected(cliente)
            setFormView(31)
            setViewOpen(true)

        }
    }

    const handleUpload = () => {
        setTipoPaquete("comprobantes")
        setIdPaquete(idComprobante)
        //console.log("arranca la subida de imagen")            
        setUpload(true)
        //setUploadComprobante(false)
    }

    return (
        <div className="w-full mx-auto">
            {!finVenta ? (
                <>
                    { venta && venta.length > 0 ? (
                        <div className='w-10/12 mx-auto'>
                            <div className='w-full mx-auto'>
                                <p className='text-center p-4 rounded-lg text-3xl font-light'>Mi pedido</p>
                                <DetallePedido />
                            </div>
                            <div className='bg-white rounded-lg sm:p-5 w-full'>
                                <div className='w-full'>
                                    <h3 className='text-center uppercase text-2xl mb-4'>Cliente</h3>
                                    {cliente && typeof cliente.id !== 'undefined' ? (
                                        <div className='rounded-lg border border-gray-800 p-2 sm:p-10 mb-5'>
                                            <p className='text-2xl text-gray-700 flex mt-3'><FaUser className='mr-4 mt-1' /> {cliente.nombre}</p>
                                            {domActual !== '' ? (
                                                <div className='flex'>
                                                    <p className='text-2xl text-gray-700 flex mt-3'><FaLocationDot className='mt-1 mr-4' /> {`${domActual} - ${obsActual}`}</p>
                                                    <button className='text-white bg-gray-400 p-2 rounded-2xl ml-3 uppercase flex mt-2'
                                                        onClick={() => editCliente(3)}
                                                    >
                                                        <FaPen className='mt-1 mr-3' />
                                                        Cambiar o Agregar Domicilio
                                                    </button>
                                                </div>

                                            ) : (
                                                <button className='text-white bg-orange-600 p-2 rounded-2xl ml-3 uppercase w-11/12 mx-auto sm:w-1/2 md:w-1/4'
                                                    onClick={() => editCliente(3)}
                                                >
                                                    Agregar Domicilio
                                                </button>
                                            )}
                                            {cliente.telefono !== 'undefined' ? (
                                                <p className='text-2xl text-gray-700 flex mt-3'><IoIosPhonePortrait className='mr-4 mt-1' /> {cliente.telefono}</p>
                                            ) : (
                                                <button className='text-white bg-orange-600 p-2 rounded-2xl ml-3 mt-2 uppercase w-11/12 mx-auto sm:w-1/2 md:1/4'
                                                    onClick={() => editCliente(3)}
                                                >
                                                    Agregar Teléfono
                                                </button>

                                            )}
                                        </div>
                                    ) : (
                                        <div className='w-full p-5'>
                                            <button className='text-white bg-indigo-600 p-2 rounded-2xl ml-3 uppercase w-full sm:w-1/4'
                                                onClick={() => {
                                                    setFormView(3);
                                                    setViewOpen(true);
                                                }}
                                            >
                                                Iniciar Sesión
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className='w-full p-3 border border-gray-800 rounded-xl'>
                                    {!custom ? (
                                        <div className="w-full sm:w-1/4 sm:items-start flex">
                                            <IoMdTime className="text-5xl mr-5 mt-2" />
                                            <button type='button'
                                                className='p-2 bg-blue-500 text-white uppercase font-semibold rounded'
                                                onClick={() => setCustom(true)}
                                            >
                                                Establecer horario de entrega
                                            </button>
                                        </div>

                                    ) : (
                                        <div className='w-full'>
                                            <div className='w-full flex'>
                                                <div className='w-1/2'><p className='text-right text-xl mr-2'>Horario específico de entrega</p></div>
                                                <div className='w-1/2'>
                                                    <input
                                                        className='text-left text-xl'
                                                        type='time'
                                                        value={horaCustom}
                                                        onChange={(e) => handleHora(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <button type='button'
                                                className='p-2 bg-orange-500 text-white uppercase font-semibold rounded'
                                                onClick={() => setCustom(false)}
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='w-full'>
                                <div className='bg-gray-50 rounded-lg p-5 sm:w-full'>
                                    {typeof medios !== 'undefined' && medios.map((item, index) =>
                                        <div key={index} className="radio">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="medioPago"
                                                    value={item.id}
                                                    checked={medioPago === item.id}
                                                    onChange={() => setMedioPago(item.id)}
                                                    className='mr-5'
                                                />
                                                {item.descripcion}
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div>
                                {medioPago === '1' ? (
                                    <div className='w-full mt-5 mb-10 bg-blue-200 rounded-lg p-5'>
                                        <div className="sm:items-start">
                                            <label className="block text-gray-800 text-2xl uppercase font-bold" htmlFor='efectivo'>Cambio o vuelto de: </label>
                                            <input
                                                type='number'
                                                className='p-2 rounded border border-gray-400 w-full'
                                                value={efectivo}
                                                id="efectivo"
                                                onChange={(e) => setEfectivo(e.target.value)}
                                                autoFocus
                                            />
                                        </div>

                                    </div>
                                ) : (
                                    <div className='w-full mt-5 mb-10 bg-blue-200 rounded-lg p-5'>
                                        <div className="sm:items-start">
                                            {parseFloat(porcentajeTransf) !== 0 && (
                                                <div>
                                                    <p className='text-red-600 uppercase'>El monto total tiene un costo adicional del {parseFloat(porcentajeTransf)}%</p>
                                                    <p className='text-gray-600 uppercase'>El recargo es de $ {(parseFloat(porcentajeTransf) * total / 100).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                                    <p className='text-gray-600 text-3xl uppercase'>Total $ {(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                                    <p className='text-red-600 uppercase'>Una vez realizada la transferencia, es necesario adjuntar el comprobante</p>
                                                    {cuentasTransf && cuentasTransf.map((item, index) => (
                                                        <div key={index} className='w-full bg-white rounded-lg border border-gray-300 p-3'>
                                                            <p className='font-bold'>Alias: {item.alias}</p>
                                                            <p className='font-bold'>Titular: {item.nombretitular}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </div>
                            <div className='sm:w-1/3 mx-auto'>
                                <button type='button'
                                    className={`w-full p-3 text-white uppercase font-semibold rounded ${cliente && cliente.domicilio !== 'undefined' ? 'bg-green-500' : 'bg-green-100 '}`}
                                    onClick={() => finalizarCompra()}
                                >
                                    Finalizar Compra
                                </button>
                            </div>
                        </div>

                    ) : (
                        <div className='w-10/12 mx-auto'>
                            <div className='w-full mx-auto'>
                                <p className='text-center p-4 rounded-lg text-3xl font-light'>Aún no tiene productos agregados a su pedido</p>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className='w-10/12 mx-auto'>
                    <div className='print:px-4 print:text-xs print:h-svh' ref={componentRef}>
                        <div className='w-full mx-auto'>
                            <p className='text-center text-2xl font-bold print:text-lg'>{nombre}</p>
                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>{`Razón Social: ${razonSocial}`}</p>
                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>{`Inicio de Act.: ${fechaInicio}`}</p>
                            <div className='w-full mt-3 mb-7'>
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Fecha {fecha}</p>
                                </div>
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Hora {hora}</p>
                                </div>
                            </div>
                        </div>
                        <DetallePedido />
                        {medioPago === '4' && uploadComprobante && (
                            <div className='w-full mt-5 mb-10 bg-blue-200 rounded-lg p-5'>
                                <h4 className='text-center text-2xl'>Subir imágen de comprobante</h4>
                                <div className="sm:items-start">
                                    <UploadFiles />
                                </div>
                                {file.length > 0 && idComprobante !== 0 && (
                                    <button type='button'
                                        className='p-2 bg-blue-500 text-white uppercase font-semibold rounded'
                                        onClick={() => handleUpload()}
                                    >
                                        Aceptar y subir imagen de comprobante
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="w-full rounded-lg px-3 flex justify-center">
                        <Link to="/">
                            <p className='text-xl text-white bg-blue-600 py-2 px-10 rounded'>Salir</p>
                        </Link>
                    </div>
                </div>
            )}
        </div>
    )
}

export default FinalizarCompra